import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'weitblick',
} as IModuleProps;
